import React, { useContext } from 'react';
import { CardContainer } from './styles';
import { ContextSolicitacoes } from '../../../../services/solicitacoes';
import { ContextoListaApartamentos } from '../../../ApartamentList/contextoImoveis';

import handleSubGrupoName from '../../../../Utils/handleSubGrupoName';

import formatDate from '../../../../Utils/formatDate';
import { ContextSindico } from '../../../../services/sindico';
import { handleDateOtherTypesSolicitation } from '../functions';

const CardSolicitacao = (props) => {
  const { getSolicitacaoUnica } = useContext(
    props?.isSindico ? ContextSindico : ContextSolicitacoes
  );

  const { tema } = useContext(ContextoListaApartamentos);

  let color = {};

  const isShowBackgroundPrimary =
    props?.item?.status === 'Em aberto' ||
    props?.item?.status === 'Em andamento' ||
    props?.item?.status === 'Em atendimento';

  if (isShowBackgroundPrimary) {
    color = { bg: tema.primaryColorFade, colorText: tema.primaryColor };
  } else {
    color = {
      bg: 'rgba(132, 132, 132, 0.4)',
      colorText: 'rgba(132, 132, 132)',
    };
  }

  const requestDateTime = () => {
    let fusoHorario = new Date().getTimezoneOffset();
    const dataAgendamento = props?.item?.dataAgendamento;
    const dataAgendamentoFinal = props?.item?.dataAgendamentoFinal;
    let requestTime = new Date(props?.item?.dataAgendamento);
    requestTime.setMinutes(fusoHorario);

    if (
      props?.item?.tipo === 'Assistência Técnica' &&
      requestTime.getHours() < 12
    ) {
      return `${formatDate(dataAgendamento)} 
      - Manhã`;
    } else if (
      props?.item?.tipo === 'Assistência Técnica' &&
      requestTime.getHours() >= 12
    ) {
      return `${formatDate(dataAgendamento)} 
      - Tarde`;
    } else {
      return handleDateOtherTypesSolicitation(
        dataAgendamento,
        dataAgendamentoFinal
      );
    }
  };

  return (
    <CardContainer color={color} tema={tema?.primaryColor}>
      <div className='solicitacaocaseNumber containerItem'>
        <span
          onClick={() => getSolicitacaoUnica(props.item.id)}
          className={'txtNumeroSolicitacao'}
        >
          {props?.item?.caseNumber}
        </span>
      </div>
      <div className='solicitacaoclassificacao containerItem'>
        <span>{handleSubGrupoName(props?.item?.tipo)}</span>
      </div>
      <div className='solicitacaodataAbertura containerItem'>
        <span>
          {formatDate(props?.item?.dataCriacaoSolicitacao) ?? '--/--/----'}
        </span>
      </div>
      <div className='solicitacaoagendamento containerItem'>
        <span>
          {props?.item?.dataAgendamento ? requestDateTime() : 'Não elegível'}
        </span>
      </div>
      <div className='solicitacaoativo containerItem'>
        <span>{props?.item?.ativo}</span>
      </div>
      <div className='solicitacaostatus containerItem'>
        <button
          className='centralized'
          onClick={() => getSolicitacaoUnica(props.item.id)}
        >
          {(props?.item?.status === 'Cancelado' ||
            props?.item?.status === 'Fechado') &&
            'Concluído'}
          {props?.item?.status === 'Em atendimento' && 'Em andamento'}
          {props?.item?.status !== 'Cancelado' &&
            props?.item?.status !== 'Em atendimento' &&
            props?.item?.status !== 'Fechado' &&
            props?.item?.status}
        </button>
      </div>
    </CardContainer>
  );
};

export default CardSolicitacao;
